module.exports = __webpack_public_path__ + "img/tu-1_09.c377c7e9.jpg";